/* istanbul ignore file */
export const MAP_LAYER_Z_INDEXES = {
    ContextLayer: 10, // allow for 50 unique context layers
    GeoJsonSiteLayer: 60,
    FieldPoint: 70, // allow for 50 unique field point markers
    Marker: 120,
    Cluster: 130,
    PinnedInfoWindow: 139,
    InfoWindow: 140
};
